import { render, staticRenderFns } from "./PlayerParts.vue?vue&type=template&id=f4e686d4&"
import script from "./PlayerParts.vue?vue&type=script&lang=js&"
export * from "./PlayerParts.vue?vue&type=script&lang=js&"
import style0 from "./PlayerParts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports